import { render, staticRenderFns } from "./ruletoordermerge.vue?vue&type=template&id=7a6ea85e"
import script from "./ruletoordermerge.vue?vue&type=script&lang=js"
export * from "./ruletoordermerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports